var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4135 10.667L12.959 13.167V8.16699L17.4135 10.667Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14063 11.552V9.78199C2.14063 6.16324 2.14062 4.35324 3.29244 3.18949C4.44553 2.02449 6.26044 1.97449 9.88899 1.87324C11.6072 1.82574 13.3635 1.79199 14.8679 1.79199C16.3723 1.79199 18.1274 1.82574 19.8468 1.87324C23.4754 1.97449 25.2903 2.02449 26.4421 3.18949C27.5939 4.35449 27.5952 6.16449 27.5952 9.78199V11.5507C27.5952 15.1707 27.5952 16.9795 26.4434 18.1445C25.2903 19.3082 23.4766 19.3595 19.8468 19.4595C18.1286 19.5082 16.3723 19.542 14.8679 19.542C13.3635 19.542 11.6084 19.5082 9.88899 19.4595C6.26044 19.3595 4.44553 19.3095 3.29244 18.1445C2.13935 16.9795 2.14063 15.1695 2.14063 11.552Z",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "white",
    transform: "translate(0.867188 0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9aba0f74a1367feb9ae31b9948f3b2dd.svg";
export { ForwardRef as ReactComponent };